module.exports = __webpack_public_path__ + "static/img/icon45.f2105ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon45.png
// module id = F1mB
// module chunks = 1